// Theme-aware color access — default export is dark theme for backward compatibility.
import { getColors as getThemeColors } from './themes';
import darkTheme from './themes/dark';

export const colors = darkTheme.colors;

export { getThemeColors as getColors };

export const meshGradient = `radial-gradient(ellipse 80% 60% at 50% -20%, ${colors.surface.gradientDevelopStart}40 0%, transparent 50%),
  radial-gradient(ellipse 60% 50% at 80% 10%, ${colors.surface.gradientPreviewEnd}28 0%, transparent 45%),
  radial-gradient(ellipse 50% 40% at 20% 30%, ${colors.surface.cyan}20 0%, transparent 40%),
  radial-gradient(ellipse 70% 50% at 60% 80%, ${colors.surface.gradientShipEnd}18 0%, transparent 50%)`;

export const primaryGradient = colors.primary[500];

export const getColor = (colorName, shade = 500) => {
  const colorPath = colorName.split('.');
  let color = colors;
  for (const path of colorPath) {
    color = color[path];
  }
  return color[shade] || color;
};

export const colorCombinations = {
  primary: {
    bg: colors.primary[500],
    text: colors.primary[900],
    hover: colors.primary[600],
  },
  secondary: {
    bg: colors.background.secondary,
    text: colors.text.primary,
    hover: colors.background.tertiary,
  },
  success: {
    bg: colors.success[500],
    text: colors.text.inverse,
    hover: colors.success[600],
  },
  warning: {
    bg: colors.warning[500],
    text: colors.text.inverse,
    hover: colors.warning[600],
  },
  danger: {
    bg: colors.danger[500],
    text: colors.text.inverse,
    hover: colors.danger[600],
  },
  info: {
    bg: colors.info[500],
    text: colors.text.inverse,
    hover: colors.info[600],
  },
};
